import { memo } from "react";

function FullScreenLoader({ loading }) {
    if (!loading) return null;
    return (
        <div
            className="fixed inset-0 flex items-center justify-center"
            style={{ backgroundColor: "rgba(0,0,0,0.4)", zIndex: 2000 }}
            role="alert"
            aria-busy="true"
            aria-label="Loading..."
        >
            <div
                className="inline-block border-4 border-current border-t-transparent rounded-full animate-spin"
                style={{ width: 40, height: 40, color: "#337ab7" }}
                role="status"
            >
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
}

export default memo(FullScreenLoader);
